import type { ToggleButtonGroupProps } from '@mui/material';
import MuIToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { forwardRef } from 'react';

const ToggleButtonGroup = forwardRef<HTMLButtonElement, ToggleButtonGroupProps>(
  (props, ref) => {
    return <MuIToggleButtonGroup ref={ref} {...props} />;
  },
);
ToggleButtonGroup.displayName = 'ToggleButtonGroup';
export default ToggleButtonGroup;
